import {
    isString,
    isNumber
} from "./main";

// 10, 10px, 20%, 20.4%, 10.3px
let ArgNumberRegExp = /^\s*\d+(\.\d+)?(%|px)\s*$/i;


let minusPlusArgNumberRegExp = /^[+-]?\s*\d+(\.\d+)?(%|px)\s*$/;

// calc can be:
// 110
// 110.5
// "110px"
// "110.5px"
// "100%"
// "22.5%"
// "calc( 100% - 110px )"
// "calc( 100px - 10% )"
// "calc( 100px - 10px )"
//
// "calc( 100px * 10px )"
// "calc( 100px / 10px )"
// "calc( 100px + 10px )"

export function calcSize(calc, size) {
    if ( isNumber(calc) ) {
        calc = calc + "px";
    }

    if ( ArgNumberRegExp.test(calc) ) {
        calc = "calc( " + calc + " )";
    }

    if ( !/^\s*calc/.test(calc) ) {
        return NaN;
    }

    calc = calc.replace(/^\s*calc\s*\(|\)\s*$/ig, "");
    // 17.2% => size * ( 17.2 / 100 )
    calc = calc.replace(/(\d+(\.\d+)?)%\s*/gi, "size * ($1 / 100)");
    calc = calc.replace(/(\d+(\.\d+)?)px\s*/gi, "$1");

    return new Function("size", "return (" + calc + ")")(size); // jshint ignore: line
}

// на входе выражение calc,
// такое же как и у функции calcSize
// нужно получить новое выражение, в котором прибавить или вычесть minusOrPlusPX
//
// minusOrPlusPXX: -20
// calc
// "100px" => "calc( 100px - 20px )"
// "calc( 100% + 20px )" => "calc( 100% + 20px - 20px )"
// "100%" => "calc( 100% - 20px )"
export function calcSizeAddPX(calc, minusOrPlusPX) {
    if ( !isNumber(minusOrPlusPX) ) {
        return NaN;
    }

    if ( isNumber(calc) ) {
        calc = calc + "px";
    }

    if ( ArgNumberRegExp.test(calc) ) {
        calc = "calc( " + calc + " )";
    }

    if ( !/calc/.test(calc) ) {
        return NaN;
    }

    calc = calc.replace(/^\s*calc\s*\(|\)\s*$/ig, "");

    if ( minusOrPlusPX > 0 ) {
        calc = calc + " + " + minusOrPlusPX + "px";
    } else {
        calc = calc + " - " + (-minusOrPlusPX) + "px";
    }

    calc = normolizeCalcContent(calc);

    return "calc( " + calc + " )";
}

export function normolizeCalcContent(calcContent) {
    let members = calcContent.replace(/([-+/*()])/g, " $1 ").trim().split(/\s+/);
    let i; let n; let member;


    let nextMember;


    let j;


    let opened = 0;


    let subContent;

    for (i = 0, n = members.length; i < n; i++) {
        member = members[ i ];
        if ( member == "(" ) {

            for (j = i + 1; j < n; j++) {
                nextMember = members[ j ];
                if ( nextMember == ")" ) {
                    if ( opened === 0 ) {
                        break;
                    }
                    opened--;
                }

                if ( nextMember == "(" ) {
                    opened++;
                }
            }

            subContent = members.slice(i + 1, j).join(" ");
            subContent = normolizeCalcContent(subContent);

            members.splice(i, j - i + 1, subContent);
            n -= (j - i);
        }
    }

    members = cutMembers(members);

    return members.join(" ");
}

function cutMembers(members) {
    let oldLength = members.length;


    let i; let n;


    let operator;


    let leftOperand;


    let rightOperand;


    let leftUnit;


    let rightUnit;

    for (i = 0, n = members.length; i < n; i++) {
        leftOperand = members[ i - 2 ];
        operator = members[ i - 1 ];
        rightOperand = members[ i ];

        if ( operator == "/" || operator == "*" ) {
            if (
                minusPlusArgNumberRegExp.test(leftOperand)
                    && isNumber(+rightOperand)
            ) {
                leftUnit = getArgUnit(leftOperand);
                leftOperand = parseFloat(leftOperand);

                if ( operator == "/" ) {
                    leftOperand /= rightOperand;
                } else {
                    leftOperand *= rightOperand;
                }

                leftOperand += leftUnit;

                i -= 2;
                n -= 2;
                members.splice(i, 3, leftOperand);
            }
        }
    }

    // [1, -, 10] => [1, +, -10]
    for (i = 0, n = members.length; i < n; i++) {
        operator = members[ i - 1 ];
        rightOperand = members[ i ];

        if (
            operator == "-"
                && minusPlusArgNumberRegExp.test(rightOperand)
        ) {
            members[ i - 1 ] = "+";

            if ( rightOperand[0] == "-" ) {
                members[ i ] = "+" + rightOperand.slice(1);
            }
            else if ( rightOperand[0] == "+" ) {
                members[ i ] = "-" + rightOperand.slice(1);
            }
            else {
                members[ i ] = "-" + rightOperand;
            }
        }
    }

    for (i = 0, n = members.length; i < n; i++) {
        leftOperand = members[ i - 2 ];
        operator = members[ i - 1 ];
        rightOperand = members[ i ];

        if (
            operator == "+"
                && minusPlusArgNumberRegExp.test(leftOperand)
                && minusPlusArgNumberRegExp.test(rightOperand)
        ) {
            leftUnit = getArgUnit(leftOperand);
            rightUnit = getArgUnit(rightOperand);

            if ( leftUnit == rightUnit ) {
                leftOperand = parseFloat(leftOperand) + parseFloat(rightOperand);
                leftOperand = leftOperand + leftUnit;

                i -= 2;
                n -= 2;
                members.splice(i, 3, leftOperand);
            }
        }
    }

    // [1, +, -10] => [1, -, 10]
    for (i = 0, n = members.length; i < n; i++) {
        operator = members[ i - 1 ];
        rightOperand = members[ i ];

        if (
            operator == "+"
                && /^-\s*\d+(\.\d+)?(%|px)\s*$/.test(rightOperand)
        ) {
            members[ i - 1 ] = "-";
            members[ i ] = rightOperand.slice(1);
        }
    }

    for (i = 0, n = members.length; i < n; i++) {
        leftOperand = members[i];
        operator = members[i + 1];
        rightOperand = members[i + 2];

        if ( operator == "+" ) {
            if ( isZero(leftOperand) && isZero(rightOperand) ) {
                members.splice(i, 3, "0px");
                i--;
                n -= 2;
            }

            else if ( isZero(leftOperand) ) {
                members.splice(i, 3, rightOperand);
                i--;
                n -= 2;
            }
            else if ( isZero(rightOperand) ) {
                members.splice(i, 3, leftOperand);
                i--;
                n -= 2;
            }
        }

        else if ( members[1] == "*" ) {
            if ( isZero(members[0]) || isZero(members[1]) ) {
                members.splice(i, 3, "0px");
                i--;
                n -= 2;
            }
        }

        else if ( members[1] == "/" ) {
            if ( isZero(leftOperand) ) {
                members.splice(i, 3, "0px");
                i--;
                n -= 2;
            }
        }
    }

    if ( members.length <= 1 ) {
        return members;
    }

    if ( members.length == oldLength ) {
        return members;
    }

    return cutMembers(members);
}

function isZero(maybeZero) {
    return isString(maybeZero) && /^[-+]?0(%|px)?$/.test(maybeZero.trim());
}

function getArgUnit(arg) {
    let symb = arg.slice(-1);
    if ( symb == "%" ) {
        return "%";
    } else {
        return "px";
    }
}

// calc( 10px ) => true
// calc( 10px - 2px ) => true
// calc( 10% ) => false
export function isStaticCalc(calc) {
    return !/%/.test(calc);
}
